import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * UTM-based auto-redirect hook for campaign traffic
 * Redirects Meta/CPC traffic to campaign-specific landing pages
 */
export const useUtmRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Skip if already on campaign page
    if (location.pathname === '/fb-family-upgrade') {
      return;
    }

    // Only redirect from home page to avoid breaking deep links
    if (location.pathname !== '/') {
      return;
    }

    const params = new URLSearchParams(location.search);
    const utmSource = params.get('utm_source')?.toLowerCase();
    const utmMedium = params.get('utm_medium')?.toLowerCase();
    const utmCampaign = params.get('utm_campaign')?.toLowerCase();

    // Meta/Facebook/Instagram traffic detection
    const isMetaTraffic = 
      utmSource === 'meta' ||
      utmSource === 'facebook' ||
      utmSource === 'fb' ||
      utmSource === 'instagram' ||
      utmSource === 'ig';

    // Paid traffic detection
    const isPaidTraffic = 
      utmMedium === 'cpc' ||
      utmMedium === 'paid' ||
      utmMedium === 'ppc' ||
      utmMedium === 'paidsocial';

    // Campaign-specific detection
    const isFamilyUpgradeCampaign = 
      utmCampaign?.includes('family') ||
      utmCampaign?.includes('upgrade') ||
      utmCampaign?.includes('makar') ||
      utmCampaign?.includes('sankranti');

    // Redirect logic: Meta traffic OR paid social traffic
    if (isMetaTraffic || (isPaidTraffic && isFamilyUpgradeCampaign)) {
      // Preserve UTM parameters in redirect
      navigate(`/fb-family-upgrade${location.search}`, { replace: true });
    }
  }, [location, navigate]);
};

export default useUtmRedirect;
